// src/constants/enums.js

// User Roles
export const UserRoles = Object.freeze({
  ADMIN: "Admin",
  SALES_MANAGER: "SalesManager",
  REGIONAL_MANAGER: "RegionalManager",
  MARKETING_HEAD: "MarketingHead",
  CUSTOMER_SERVICE: "CustomerService",
  VP_SALES: "VPSales",
  CFO: "CFO",
  CCSUPERVISOR: "CCSupervisor",
  CUSTOMER: "Customer",
  LOGISTIC_MANAGER: "LogisticManager",
  LOGISTIC_SUPERVISOR: "LogisticSupervisor",
  CEO: "CEO",
  CC_MANAGER: "CCManager",
  LOGISTIC_RESPONSIBLE: "LogisticResponsible",
  MARKETING_MANAGER: "MarketingManager",
  EXTERNAL: "External",
  DEFAULT: "Default",
});

// Path Enum
export const Paths = Object.freeze({
  // Public Route Paths
  ROOT: "/",
  ADD_CUSTOMER: "/add-customer",
  UPDATE_CUSTOMER: "/update-customer",
  REGISTRATION_SUCCESS: "/registration-success",
  WILDCARD: "*",
  // Dashboard Paths
  EXECUTIVE_SUMMARY: "/Executive-Summary",
  SELLER_DASHBOARD: "/seller-dashboard",
  SALES_MANAGER_DASHBOARD: "/sales-manager-dashboard",
  CUSTOMER_SERVICE_DASHBOARD: "/cc-CustomerService-dashboard",
  CUSTOMER_DASHBOARD: "/customer-dashboard",
  CC_SUPERVISOR_DASHBOARD: "/cc-supervisor-dashboard",
  LOGISTIC_SUPERVISOR_DASHBOARD: "/logistic-supervisor-dashboard",
  EXECUTIVE_DASHBOARD: "/Executive-Dashboard",
  CC_MANAGER_DASHBOARD: "/cc-manager-dashboard",
  ADMIN_DASHBOARD: "/admin-dashboard",
  MARKETINGMANAGER_DASHBOARD: "/marketing-dashboad",

  // Customer Paths
  ONBOARDED_CUSTOMERS: "/onboarded-customers",
  APPROVAL_CUSTOMER: "/approval-customer",
  CUSTOMER_REGION: "/customer-region",
  SUBCUSTOMER_REGION: "/customer-sub-region",
  CUSTOMER_TYPE: "/customer-type",
  CUSTOMERS_HERARCHICAL: "/customers-herarchical",
  CUSTOMER_PRICE_LIST: "/customer-price-list",
  CUSTOMER_BACK_ORDER: "/customer-back-order",

  CUSTOMER_HERARCHY_LEVEL: "/Customer-Access-Control",

  // Invoice Paths
  INVOICES: "/invoices",

  // Payment Paths
  CUSTOMER_PAYMENTS: "/Customer-payments",
  PAYMENTS: "/payments",
  PAYMENT_CUSTOMER: "/payment-customer",

  // Logistic Paths
  LOGISTIC_CUSTOMER: "/logistic-customer",
  LOGISTIC: "/logistic",

  // Dispute Paths
  RAISED_DISPUTE: "/raised-dispute",
  DISPUTE_DETAILS: "/dispute-details",
  DISPUTE_LEVEL_ASSIGNMENT: "/dispute-level-assignment",
  DISPUTE_ESCALATION_CONFIGURATION: "/dispute-escalation-configuration",

  // Account Statement Paths
  VIEW_ACCOUNT_STATMENT: "/view-account-statement",
  CUSTOMER_ACCOUNT_STATMENT: "/customer-account-statement",

  // Management Paths
  BUSINESS_UNIT: "/business-unit",
  ROLE: "/role",
  DEPARTMENT: "/department",
  DESIGNATION: "/designation",
  PRIVILEGE: "/privilege",
  USERPRIVILEGE: "/UserTable",
  ROLEPRIVILEGE: "/RoleTables",
  USERS: "/users",
  APPROVAL_LEVEL_ASSIGNMENT: "/approval-level-assignment",
  PROMOTION: "/Promotion",
  BULK_UPLOAD: "/bulk-upload",
  JK_BANK_ACCOUNT: "/jk-bank-account",
  ASSIGN_PAYMENT_ACCOUNTS: "/assign-payment-accounts",

  // Credit Paths
  CREDIT_LINE: "/credit-line",
  CREDIT_LINE_REQUEST: "/credit-line-request",

  // Profile and Guides
  MY_PROFILE: "/my-profile",
  USER_GUIDE: "/user-guide",

  // Customer Feedback
  CUSTOMER_FEEDBACK: "/customer-feedback",

  // Fallback
  UNKNOWN_ROLE: "/unknown-role",
});

export const Components = Object.freeze({
  // Dashboards
  EXECUTIVE_DASHBOARD: "ExecutiveDashboard",
  ADMIN_DASHBOARD: "AdminDashboard",
  DASHBOARD: "Dashboard",
  CUSTOMER_DASHBOARD: "CustomerDashboard",

  // Customer Components
  ONBOARDED_CUSTOMERS: "OnboardedCustomers",
  APPROVAL_CUSTOMER: "ApprovalCustomer",
  CUSTOMER_REGION: "CustomerRegion",
  SUBCUSTOMER_REGION: "CustomerSubRegion",
  CUSTOMER_TYPE: "CustomerType",
  CUSTOMERS_HIERARCHY: "CustomersHierarchy",
  CUSTOMER_PRICE_LIST: "ViewCustomerPriceList",
  CUSTOMER_BACK_ORDER: "ViewCustomerBackOrder",

  // Invoice Components
  VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS: "ViewInvoiceAndCreditNoteDetails",
  INVOICE_CUSTOMER: "InvoiceCustomer",

  // Payment Components
  VIEW_PAYMENT_DETAILS: "ViewPaymentDetails",
  PAYMENTS: "Payments",
  PAYMENTS_CUSTOMER: "PaymentsCustomer",

  // Logistic Components
  LOGISTIC_DETAILS: "LogisticDetails",
  VIEW_LOGISTIC_DETAILS: "ViewLogisticDetails",

  // Dispute Components
  RAISED_DISPUTE: "RaisedDispute",
  DISPUTE_DETAILS: "DisputeDetails",
  DISPUTE_LEVELS_MANAGEMENT_PAGE: "DisputeLevelsManagementPage",
  DISPUTE_ESCALATION_CONFIGURATION_PAGE: "DisputeEscalationConfigurationPage",

  // Account Statement Components
  VIEW_ACCOUNT_STATMENT: "ViewAccountStatment",
  ACCOUNT_STATEMENT_DETAILS: "AccountStatementDetails",

  // Management Components
  LEVELS_MANAGEMENT_PAGE: "LevelsManagementPage",
  ROLE: "Role",
  DEPARTMENT: "Department",
  DESIGNATION: "Designation",
  PRIVILEGE: "Privilege",
  USERPRIVILEGE: "UserTable",
  ROLEPRIVILEGE: "RoleTables",
  EMPLOYEE: "Employee",
  BUSINESS_UNIT: "BusinessUnit",
  CUSTOMER_HERARCHY_LEVEL: "CustomerLevelHerarchy",
  PROMOTION: "Promotion",
  BULK_UPLOAD: "BulkUpload",
  JK_BANK_ACCOUNT: "JkBankAccount",
  ASSIGN_PAYMENT_ACCOUNTS: "AssignPaymentAccounts",

  // Credit Components
  CREDIT_LINE_CUSTOMER: "CreditLineCustomer",
  CREDIT_LINE_DETAILS: "CreditLineDetails",

  // Profile and Guides
  USER_PROFILE: "UserProfile",
  USER_GUIDE_LIST: "UserGuideList",

  // Customer Feedback
  CUSTOMER_FEEDBACK: "CustomerFeedbackTable",

  // Fallback
  REDIRECT_TO_ROLE_DASHBOARD: "UnconfiguredRolePage",
});

// Status Enum
export const Status = Object.freeze({
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ACC_FULLPAYMENT: "FULLPAYMENT",
});

export const LogisticStatus = Object.freeze({
  ROBBED: "Robbed",
  DELIVERED: "Delivered",
});

// Language options
export const Language = Object.freeze({
  ENGLISH: "en",
  SPANISH: "es",
});

// UI Theme
export const ThemeMode = Object.freeze({
  LIGHT: "light",
  DARK: "dark",
});

export const CommonEnums = Object.freeze({
  YES: "Yes",
  NO: "No",
  INTERNATIONAL: "international",
  DOMESTIC: "domestic",
  MEXICO: "MEXICO",
  INDIVIDUAL: "Individual",
  COMPANY: "Company",
});
